import React, {FC} from "react";
import {Card} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowInput} from "@components/panel/formik";
import {GoalConditionType} from "@interfaces/consumer/refs";
import {GoalConditionFormValues} from "./conditionBaseInfoBlock";

const ConditionDonateBlock: FC = () => {
    const {values} = useFormikContext<GoalConditionFormValues>();

    if (values.type !== GoalConditionType.Donate) {
        return null;
    }

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Параметры доната</Card.Header>
            <Card.Body>
                <Field
                    label="Сумма доната"
                    name="donateValue"
                    type="number"
                    component={FormikRowInput}
                />
            </Card.Body>
        </Card>
    );
};

export default ConditionDonateBlock;
